import { union } from "../../shared/src/codecs/types/union";
import { literal } from "../../shared/src/codecs/types/literal";

export const ListingPriceQualifier = union([
    literal("guide_price"), literal("offers_over"), literal("fixed_price"), literal("oiro")
]);
